import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { NOT_AVAILABLE_VALUE } from "./constants";

export const EmptyStatePlaceholder = () => {
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            flex="1"
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[300]}
            >
                {NOT_AVAILABLE_VALUE}
            </Text>
        </Flex>
    );
};
